import { FitpetIcon } from '@fitpet/ui/components'
import { clsx } from 'clsx'
import styles from './SelectBox.module.css'

const DELAY_TIME = 150

interface SelectBoxProps {
  onClick: () => void
  value?: string
  placeholder?: string
}

const SelectBox = ({ onClick, value, placeholder }: SelectBoxProps) => {
  const handleClick = () => {
    setTimeout(() => {
      onClick()
    }, DELAY_TIME)
  }
  return (
    <button type="button" className={styles.selectBox} onClick={handleClick}>
      <span className={clsx(styles.selectBoxValue, 'font-body3-regular gray-700')}>{value || placeholder}</span>
      <FitpetIcon icon="icChevronDown" size={24} />
    </button>
  )
}

export default SelectBox
